let playerEls = document.querySelectorAll( '.player' );
if ( playerEls ) {
	playerEls.forEach( ( playerEl, i ) => {
		playerEl.addEventListener( 'click', ( e ) => {
			let iframeEl = playerEl.querySelector( '.player-iframe' );
			playerEl.querySelector( '.player-preview' ).remove();
			iframeEl.setAttribute( 'src', iframeEl.getAttribute( 'data-src' ) );
		} );
	} );
}